var _path, _mask, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlumbrado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M24.884 40.06c-.865 0-1.569.704-1.569 1.569v6.802c0 .865.704 1.569 1.569 1.569.864 0 1.568-.704 1.568-1.569V41.63c0-.865-.704-1.569-1.568-1.569",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "h9r43gn2ca",
    width: 38,
    height: 37,
    x: 6,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 0h37.768v36.394H6V0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h9r43gn2ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M25.262 33.257c-2.346 0-4.442-1.467-5.259-3.666H30.52c-.816 2.199-2.912 3.666-5.258 3.666m16.037-14.713c-.434-.75-1.395-1.006-2.143-.573-.749.433-1.005 1.395-.572 2.143 1.146 1.98 1.817 4.114 1.996 6.34l-31.434-.016c.806-8.121 7.553-14.231 15.738-14.231 2.014 0 3.976.373 5.83 1.108.388.155.814.149 1.198-.017.386-.166.683-.472.838-.862.154-.39.148-.816-.018-1.2-.167-.386-.473-.683-.862-.837-1.709-.678-3.53-1.1-5.418-1.253V1.568C26.452.703 25.748 0 24.884 0c-.865 0-1.569.703-1.569 1.568v7.57c-9.179.74-16.45 7.924-17.302 17.112-.08.848.206 1.697.784 2.33.585.643 1.42 1.011 2.288 1.011h7.65c.902 3.947 4.475 6.803 8.527 6.803 4.051 0 7.624-2.856 8.526-6.803h6.895c.868 0 1.703-.368 2.288-1.01.576-.634.863-1.483.784-2.33-.254-2.737-1.08-5.33-2.456-7.707",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M34.925 37.735c-.297-.296-.69-.46-1.11-.46-.418 0-.812.164-1.109.46-.61.612-.61 1.607 0 2.219l4.811 4.81c.296.296.69.459 1.109.459.419 0 .813-.163 1.109-.46.611-.61.611-1.606 0-2.217l-4.81-4.81zM15.951 37.276c-.419 0-.812.163-1.109.46l-4.81 4.81c-.611.611-.611 1.607 0 2.217.296.297.69.46 1.109.46.419 0 .812-.163 1.109-.46l4.81-4.81c.612-.611.612-1.606 0-2.218-.296-.296-.69-.46-1.109-.46",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumbrado);
export default __webpack_public_path__ + "static/media/alumbrado.b47e373f0c390b45a6452031c34d294d.svg";
export { ForwardRef as ReactComponent };